import * as Constants from "../../config/constants/Constants.js";
import { getLanguage } from "../../config/language/language.js";
import { getFetch, putFetch, catchAPIResponse } from "./http.js";
import { sessionExpired } from "./authQueries.js";

export const queryAdminSettings = async (props) => {
    const response = await getFetch(Constants.API_ADMIN_SETTINGS, props.user.userJWT);
    if (!response.ok) {
        catchAPIResponse(props, response, {
            onUnauthorized: () => sessionExpired(props),
        });
        return null;
    }
    return response.body;
};

export const updateAdminSettings = async (props, settings) => {
    const response = await putFetch(Constants.API_ADMIN_SETTINGS, settings, props.user.userJWT);
    if (!response.ok) {
        catchAPIResponse(props, response, {
            onUnauthorized: () => sessionExpired(props),
        });
        return null;
    }
    props.showSnackbar({ color: "success", message: getLanguage().SNACKBAR_SUCCESS_SETTINGS });
    if (props.auth?.setAuthStatus) {
        props.auth.setAuthStatus((prev) => ({
            ...(prev || {}),
            ...response.body,
            requiresLogin: response.body.authEnabled && !response.body.publicAccessActive,
        }));
    }
    return response.body;
};
